/* jshint esversion: 6 */
/* jshint ignore:start */

import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import ShowPassword from "../Icon/eye.svg";
import HidePassword from "../Icon/eye-slash.svg";
import { VscVerifiedFilled } from "react-icons/vsc";
import axios from "axios";
import { showTost } from "../showTost";

// Country code data
const countryCodes = [
  { code: "+1", name: "USA/Canada" },
  { code: "+44", name: "UK" },
  { code: "+91", name: "India" },
  { code: "+61", name: "Australia" },
  { code: "+33", name: "France" },
  { code: "+49", name: "Germany" },
  { code: "+81", name: "Japan" },
  { code: "+86", name: "China" },
  { code: "+92", name: "Pakistan" },
  { code: "+880", name: "Bangladesh" },
  { code: "+971", name: "UAE" },
  { code: "+966", name: "Saudi Arabia" },
  { code: "+39", name: "Italy" },
  { code: "+34", name: "Spain" },
  { code: "+7", name: "Russia" },
  { code: "+82", name: "South Korea" },
  { code: "+62", name: "Indonesia" },
  { code: "+60", name: "Malaysia" },
  { code: "+63", name: "Philippines" },
  { code: "+94", name: "Sri Lanka" },
  { code: "+254", name: "Kenya" },
  { code: "+27", name: "South Africa" },
  { code: "+20", name: "Egypt" },
  { code: "+55", name: "Brazil" },
  { code: "+351", name: "Portugal" },
  { code: "+46", name: "Sweden" },
  { code: "+45", name: "Denmark" },
  { code: "+41", name: "Switzerland" },
  { code: "+31", name: "Netherlands" },
  { code: "+48", name: "Poland" },
  { code: "+90", name: "Turkey" }
];

// Interest options
const interestOptions = [
  "Music", "Sports", "Reading", "Travel", "Cooking",
  "Photography", "Gaming", "Art", "Dancing", "Hiking"
];

const Register = () => {
  // Form state with all required fields
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    mobile: "",
    ccode: "+44",
    birth_date: "1995-05-10",
    search_preference: "female",
    radius_search: "50",
    relation_goal: "friendship",
    profile_bio: "Hello, I love hiking!",
    interests: [],
    language: "english,spanish",
    refercode: "379868",
    gender: "MALE",
    lats: "51.509865",
    longs: "-0.118092",
    religion: "Christian",
    size: "1"
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [debugInfo, setDebugInfo] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleInterestChange = (interest) => {
    setFormData(prev => {
      const newInterests = prev.interests.includes(interest)
        ? prev.interests.filter(i => i !== interest)
        : [...prev.interests, interest];
      return { ...prev, interests: newInterests };
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setDebugInfo(null);

    // Validate required fields
    if (!formData.firstName || !formData.lastName) {
      showTost({ title: "Please Enter First and Last Name" });
      setIsSubmitting(false);
      return;
    }
    
    if (!formData.email) {
      showTost({ title: "Please Enter Email" });
      setIsSubmitting(false);
      return;
    }
    
    if (!formData.password) {
      showTost({ title: "Please Enter Password" });
      setIsSubmitting(false);
      return;
    }

    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      showTost({ title: "Passwords do not match" });
      setIsSubmitting(false);
      return;
    }

    if (!formData.mobile) {
      showTost({ title: "Please Enter Mobile Number" });
      setIsSubmitting(false);
      return;
    }

    // Email validation
    const emailValidation = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    if (!emailValidation.test(formData.email)) {
      showTost({ title: "Please Enter Valid Email" });
      setIsSubmitting(false);
      return;
    }

    try {
      // Create FormData object
      const formDataToSend = new FormData();
      
      // Combine first and last name
      const fullName = `${formData.firstName} ${formData.lastName}`;
      formDataToSend.append('name', fullName);
      
      // Add all other fields (except confirmPassword)
      for (const key in formData) {
        if (key !== 'firstName' && key !== 'lastName' && key !== 'confirmPassword') {
          formDataToSend.append(key, Array.isArray(formData[key]) 
            ? formData[key].join(',') 
            : formData[key]);
        }
      }

      // Debug: Log the data being sent
      console.log("FormData contents:");
      for (let [key, value] of formDataToSend.entries()) {
        console.log(key, value);
      }

      const startTime = Date.now();
      const response = await axios.post(
        "https://api.fwaye.com/api/reg_user.php",
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          transformRequest: (data, headers) => {
            delete headers['Content-Type'];
            return data;
          }
        }
      );
      const endTime = Date.now();

      // Debug info
      const debugData = {
        request: {
          url: "https://api.fwaye.com/api/reg_user.php",
          method: "POST",
          payload: Object.fromEntries(formDataToSend),
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        },
        response: {
          status: response.status,
          data: response.data,
          headers: response.headers,
          timeTaken: `${endTime - startTime}ms`
        },
        timestamp: new Date().toISOString()
      };

      setDebugInfo(debugData);
      console.log("Full debug info:", debugData);

      if (response.data.Result === "true") {
        showTost({ title: "Registration successful!" });
      } else {
        showTost({ title: response.data.ResponseMsg || "Registration failed" });
      }
    } catch (error) {
      let errorMessage = "Registration failed. Please try again.";
      let errorDetails = {};

      if (error.response) {
        errorDetails = {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers
        };
        errorMessage = error.response.data?.ResponseMsg || errorMessage;
      } else if (error.request) {
        errorDetails = { message: "No response received", request: error.request };
        errorMessage = "No response from server. Please check your connection.";
      } else {
        errorDetails = { message: error.message };
      }

      console.error("Registration Error:", error, errorDetails);
      setDebugInfo({
        error: errorDetails,
        timestamp: new Date().toISOString()
      });
      showTost({ title: errorMessage });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="w-[100%] multisteup-wrapper pt-[20px] Test">
      <div className="container mx-auto">
        <section className="steps step-1 active rounded-[40px] relative">
          {/* Progress Bar */}
          <div className="w-[100%] bg-[#EFEDEE] pt-[30px] z-[999] pb-[20px] fixed top-[0px]">
            <div className="bg-white w-[83%] h-[5px] mx-auto rounded-full">
              <div className="bg-[#2280c3] rounded-full w-[9%] h-[5px]"></div>
            </div>
          </div>
          
          {/* Title */}
          <div>
            <h1 className="text-[28px] max-_430_:text-[27px] font-[600]">
              Can You elaborate on your identity? &#128526;
            </h1>
            <p className="text-[20px] mt-[10px] max-_430_:text-[20px] max-_380_:text-[16px]">
              It will Display on your Profile and you will not able to change
              it later
            </p>
          </div>
          
          {/* Form */}
          <form onSubmit={handleSubmit} className="mt-[20px] w-[100%]">
            {/* First and Last Name */}
            <div className="grid grid-cols-2 gap-4">
              <div className="relative">
                <input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[20px] py-[15px] rounded-[10px]"
                  type="text"
                  placeholder="First Name"
                  required
                />
                {formData.firstName && (
                  <VscVerifiedFilled className="w-[25px] h-[25px] absolute bottom-[12px] right-5" />
                )}
              </div>
              <div className="relative">
                <input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[20px] py-[15px] rounded-[10px]"
                  type="text"
                  placeholder="Last Name"
                  required
                />
                {formData.lastName && (
                  <VscVerifiedFilled className="w-[25px] h-[25px] absolute bottom-[12px] right-5" />
                )}
              </div>
            </div>
            
            {/* Email */}
            <div className="relative mt-[10px]">
              <input
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                type="email"
                placeholder="Email"
                required
              />
              {formData.email && (
                <VscVerifiedFilled className="w-[25px] h-[25px] absolute bottom-[12px] right-5" />
              )}
            </div>
            
            {/* Password */}
            <div className="relative mt-[10px]">
              <input
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                required
              />
              <button 
                type="button"
                onClick={togglePasswordVisibility}
                className="absolute bottom-[17px] right-5"
              >
                <img
                  alt={showPassword ? "Hide" : "Show"}
                  src={showPassword ? HidePassword : ShowPassword}
                  className="w-[25px] h-[25px]"
                />
              </button>
            </div>
            
            {/* Confirm Password */}
            <div className="relative mt-[10px]">
              <input
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirm Password"
                required
              />
              <button 
                type="button"
                onClick={toggleConfirmPasswordVisibility}
                className="absolute bottom-[17px] right-5"
              >
                <img
                  alt={showConfirmPassword ? "Hide" : "Show"}
                  src={showConfirmPassword ? HidePassword : ShowPassword}
                  className="w-[25px] h-[25px]"
                />
              </button>
            </div>
            
            {/* Mobile Number with Country Code */}
            <div className="grid grid-cols-3 gap-2 mt-[10px]">
              <div className="col-span-1">
                <select
                  name="ccode"
                  value={formData.ccode}
                  onChange={handleChange}
                  className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                >
                  {countryCodes.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.name} ({country.code})
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-span-2">
                <input
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                  type="tel"
                  placeholder="Mobile Number"
                  required
                />
              </div>
            </div>
            
            {/* Birth Date */}
            <div className="mt-[10px]">
              <label className="block text-gray-700 mb-1">Birth Date</label>
              <input
                name="birth_date"
                value={formData.birth_date}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                type="date"
              />
            </div>
            
            {/* Gender */}
            <div className="mt-[10px]">
              <label className="block text-gray-700 mb-1">Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
              >
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
                <option value="OTHER">Other</option>
              </select>
            </div>
            
            {/* Search Preference */}
            <div className="mt-[10px]">
              <label className="block text-gray-700 mb-1">Looking For</label>
              <select
                name="search_preference"
                value={formData.search_preference}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
              >
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="both">Both</option>
              </select>
            </div>
            
            {/* Interests */}
            <div className="mt-[10px]">
              <label className="block text-gray-700 mb-1">Interests (Select multiple)</label>
              <div className="grid grid-cols-2 gap-2">
                {interestOptions.map((interest) => (
                  <div key={interest} className="flex items-center">
                    <input
                      type="checkbox"
                      id={`interest-${interest}`}
                      checked={formData.interests.includes(interest)}
                      onChange={() => handleInterestChange(interest)}
                      className="mr-2"
                    />
                    <label htmlFor={`interest-${interest}`}>{interest}</label>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Referral Code */}
            <div className="mt-[10px]">
              <input
                name="refercode"
                value={formData.refercode}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                type="text"
                placeholder="Referral Code"
              />
            </div>
            
            {/* Bio */}
            <div className="mt-[10px]">
              <textarea
                name="profile_bio"
                value={formData.profile_bio}
                onChange={handleChange}
                className="text-black w-[100%] border-[2px] outline-[#2280c3] border-gray-300 px-[15px] py-[15px] rounded-[10px]"
                placeholder="Tell us about yourself"
                rows="3"
              />
            </div>
            
            {/* Hidden Fields */}
            <input type="hidden" name="radius_search" value={formData.radius_search} />
            <input type="hidden" name="relation_goal" value={formData.relation_goal} />
            <input type="hidden" name="language" value={formData.language} />
            <input type="hidden" name="lats" value={formData.lats} />
            <input type="hidden" name="longs" value={formData.longs} />
            <input type="hidden" name="religion" value={formData.religion} />
            <input type="hidden" name="size" value={formData.size} />
            
            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              style={{ background: "#2280c3" }}
              className="btn btn-w-md nextstep mt-[50px] w-full"
            >
              <div className="flex items-center justify-center gap-[10px]">
                <span className="font-bold text-[1.25rem] text-white">
                  {isSubmitting ? "Processing..." : "Register"}
                </span>
              </div>
            </button>
          </form>
          
        </section>
      </div>
    </div>
  );
};

export default Register;
/* jshint ignore:end */